import './RobotLoader.css';

import type { RobotLoaderProps } from './RobotLoader.types';

// Hand-drawn robot sweeping a magnifying glass — scanning eyes, blinking
// antenna beacon and "thinking" dots. Animations live in RobotLoader.css.
export const RobotLoader = ({ label, className = '' }: RobotLoaderProps) => (
	<div
		role="status"
		aria-live="polite"
		className={`flex flex-col items-center gap-3xs py-md text-purple-700 ${className}`}
	>
		<svg width="56" height="50" viewBox="0 0 64 56" fill="none" aria-hidden="true" className="robot-loader__bob">
			{/* Antenna */}
			<circle className="robot-loader__beacon" cx="32" cy="5" r="2" fill="currentColor" />
			<line x1="32" y1="7" x2="32" y2="11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />

			{/* Head */}
			<rect x="20" y="11" width="24" height="17" rx="5" stroke="currentColor" strokeWidth="2" />
			<rect x="16" y="16" width="3" height="6" rx="1.5" fill="currentColor" opacity="0.5" />
			<rect x="45" y="16" width="3" height="6" rx="1.5" fill="currentColor" opacity="0.5" />
			<g className="robot-loader__eyes">
				<circle cx="28" cy="18.5" r="2.2" fill="currentColor" />
				<circle cx="36" cy="18.5" r="2.2" fill="currentColor" />
			</g>
			<rect x="28" y="23.5" width="8" height="1.6" rx="0.8" fill="currentColor" opacity="0.45" />

			{/* Body */}
			<rect x="24" y="30" width="16" height="12" rx="4" stroke="currentColor" strokeWidth="2" />
			<circle cx="32" cy="36" r="1.6" fill="currentColor" opacity="0.5" />
			<line x1="29" y1="42" x2="29" y2="46" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
			<line x1="35" y1="42" x2="35" y2="46" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />

			{/* Left arm */}
			<path d="M24 33 Q19 35 19.5 40" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />

			{/* Right arm sweeping the magnifying glass — held upright, glass raised above the hand */}
			<g className="robot-loader__magnifier">
				<path d="M40 33 Q44 34 45.5 36" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
				<line x1="45.5" y1="36" x2="47.5" y2="31.2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
				<circle cx="49" cy="27.5" r="4" stroke="currentColor" strokeWidth="2" />
			</g>

			{/* Thinking dots */}
			<circle className="robot-loader__dot" cx="26" cy="52.5" r="1.8" fill="currentColor" />
			<circle className="robot-loader__dot robot-loader__dot--2" cx="32" cy="52.5" r="1.8" fill="currentColor" />
			<circle className="robot-loader__dot robot-loader__dot--3" cx="38" cy="52.5" r="1.8" fill="currentColor" />
		</svg>
		{label && <p className="text-[11px] text-subtle">{label}</p>}
	</div>
);
